/* globals define */

/*
  Purpose:
    - to allow sticky header feature in homepage, plp, and pip

  Dependencies:
    - jquery, hfConfig
*/

(function closure(root, factory) {
    /* istanbul ignore else  */
    if (typeof define === 'function' && define.amd) {
      define('header.sticky', ['jquery', 'hfConfig'],
        function load(jQuery, hfConfig) {
          return factory(root, jQuery, hfConfig);
        });
    } else {
      // For non-AMD module, expose this to global (will also be useful for test cases)
      /*eslint-disable*/
      var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
      _hfapp.sticky = factory(root, jQuery, hfConfig);
      /*eslint-enable*/
    }
  })(this, function factory(root, $, hfConfig) {
    var module = {};
    var privateMethods = {};
    var isStickyPage = hfConfig.isHomePage || hfConfig.isPLPPage || hfConfig.isPIPPage;
  
    privateMethods.initialize = function initialize() {
      if (isStickyPage) {
        $('.Header3').addClass('Header3-sticky');
      }
    };
  
    /*
      * Public Methods
      */
    module.getPrivateMethods = function getPrivateMethods() {
      return privateMethods;
    };
  
    module.init = function init() {
      privateMethods.initialize();
      return this;
    };
    return module;
  });